import React from "react";
import Language from "../lib/Language";

type TSummaryBarProps = {
    displaySumWindow: () => void;
    summaryText: string;
};

class SummaryBar extends React.Component<TSummaryBarProps> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClick(event) {
        event.stopPropagation();
        this.props.displaySumWindow();
    }

    render() {
        return (
            <div className="summaryWrapper">
                <div className="summaryBar">
                    <span className="summaryText">{this.props.summaryText}</span>
                    <button
                        className="deprecated summaryButton"
                        title={Language.get("nc_reservation_summary")}
                        onClick={this.onClick.bind(this)}
                    />
                </div>
            </div>
        );
    }
    shouldComponentUpdate(prevProps) {
        return this.props.summaryText !== prevProps.summaryText;
    }
}

export default SummaryBar;
